import { createSelector } from 'reselect';
import { featuresSelector } from 'ai/selectors/testTarget/aiBeautyChat/features/featuresSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const featuresAIBeautyChatSelector = createSelector(isTestTargetReadySelector, featuresSelector, (testReady, features) => testReady && features);

export { featuresAIBeautyChatSelector };
